import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ErrorService } from 'src/app/services/error.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';
import * as PolitikiGiActions from '../actions/politiki-gi.actions';
import { AppState } from '../app.reducer';
import { TranslationService } from 'src/app/services/translation.service';
import { IPolitikiGiModel, PolitikiGiModel } from 'src/app/core/models/politiki_gi.model';



@Injectable()
export class PolitikiGiEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private errorService: ErrorService,
    private store: Store<AppState>,
    private toastService: ToastService,
    private translationService: TranslationService
  ) { }
    payloadReload;

  getPolitikiGiByKadik$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolitikiGiActions.getPolitikiGiByKadik),
      switchMap(({payload}) => {
        PolitikiGiActions.politikiGiLoading({ payload: { loading: true } });
        return this.http

          .get<any>(environment.apiUrl + `/politikigi/`+ payload.kadik)
          .pipe(
            map((x) => {
              return x.data;
            }),
            switchMap((response) => {
              this.store.dispatch(
                PolitikiGiActions.getPolitikiGiByKadikSuccess({
                  payload: {
                    politiki_gi: response,
                  },
                })
              );
              return of(
                 PolitikiGiActions.politikiGiLoading({ payload: { loading: false } })
              );
            }),
            catchError((error) => {
              this.store.dispatch(
                PolitikiGiActions.politikiGiFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
              return of(
                 PolitikiGiActions.politikiGiLoading({ payload: { loading: true } })
              );
            })
          );
      })
    )
  );
createPolitikiGi$ = createEffect(() =>
  this.actions$.pipe(
    ofType(PolitikiGiActions.createPolitikiGi),
    switchMap((data) => {
    this.store.dispatch(PolitikiGiActions.politikiGiLoading({ payload: { loading: true } }));
     return this.http
    .post<{ id: number }>(environment.apiUrl + '/politikigi/create/', data.payload)
.pipe(
    map((payload) => PolitikiGiActions.politikiGiCreated ({ id: payload.id })),
        catchError(error =>
          of(PolitikiGiActions.politikiGiFail({ payload: { error: this.errorService.mapError(error) } }))
        )
      );
})
  )
);


  updatePolitikiGi$ = createEffect(() => {
  return this.actions$.pipe(
    ofType(PolitikiGiActions.updatePolitikiGi),
    switchMap(({ payload }) => {
      this.store.dispatch(
        PolitikiGiActions.politikiGiLoading({ payload: { loading: true } })
      );
       return this.http.put<IPolitikiGiModel>(
               environment.apiUrl +`/politikigi/update/`+ payload.kadik,
           payload.politiki_gi
          ).pipe(
            switchMap(() => {
              return of(
                 PolitikiGiActions.updatePolitikiGiSuccess(),
                PolitikiGiActions.politikiGiLoading({ payload: { loading: false } })
              );
            }),
            catchError((error) => {
              return of(
                PolitikiGiActions.politikiGiFail({
                  payload: { error: this.errorService.mapError(error) },
                }),
                PolitikiGiActions.politikiGiLoading({ payload: { loading: false } })
              );
            })
          );
    })
  );
});

 deleteParcel$ = createEffect(() =>
     this.actions$.pipe(
       ofType(PolitikiGiActions.deletePolitikiGi),
       switchMap((payload) => {
         PolitikiGiActions.politikiGiLoading({ payload: { loading: true } });
         return this.http
           .delete<any>(environment.apiUrl + '/politikigi/delete/' + payload.payload.kadik)
           .pipe(
             map((x) => {
               return x.data;
             }),
             switchMap((responseData) => {
               this.store.dispatch(
                 PolitikiGiActions.deletePolitikiGiSuccess({
                   payload: {
                     politiki_gi: responseData,
                   },
                 })
               );
               this.toastService.showToast(`${this.translationService.translate('STATUS_UPDATE.DELETE')}`);
               return of(
                   PolitikiGiActions.politikiGiLoading({ payload: { loading: true } })
               );
             }),
             catchError((error) => {
               this.store.dispatch(   PolitikiGiActions.politikiGiLoading({ payload: { loading: false } }));
               return of(
                 PolitikiGiActions.politikiGiFail({
                   payload: { error: this.errorService.mapError(error) },
                 })
               );
             })
           );
       })
     )
   );
  }